module.exports = __webpack_public_path__ + "img/icon_chatNotnotice.5d7d889d.png";